import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorBaseComponent } from './error-base.component';


@NgModule({
  declarations: [
    ErrorBaseComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class ErrorBaseModule { }
